import React, { FunctionComponent } from "react";
import WizardContainer, { WizardProps } from "../../containers/Wizard";
import { STATE_PATH, PHONE_PATH } from "../../routing/paths";
import FillOrigamiStep from "../FillOrigamiStep";

const POSTAL_CODE_SPELL_NAME = "zip";

const FillOrigamiStepProps = {
  previous: STATE_PATH,
  next: PHONE_PATH,
  question: "What's the <%= target %> Code",
  target: "zip/postal",
  spellName: POSTAL_CODE_SPELL_NAME,
  placeholder: "78701",
  required: false  
};

export const PostalCodeStep: FunctionComponent<WizardProps> = (props: WizardProps) => (
  <FillOrigamiStep wizard={props} {...FillOrigamiStepProps} />
);

export default WizardContainer(PostalCodeStep);
